// extracted by mini-css-extract-plugin
module.exports = {"block":"_6548","group":"_9348","title":"_12768","list":"_3828","item":"_16803","name":"_14720","count":"_15221","price":"_7539","dash":"_17206","highlight":"_11002"};